/**
 * Agence'O - Carenews
 * @author Adrien Crivellaro (Agence'O)
 * @created 28/10/2019
 */
(function ($) {

  $( document ).ready(function() {
  var maxHeightHeader = 0;
  $("#choix-inscription .card-header").each(function(){
    if ($(this).height() > maxHeightHeader) { maxHeightHeader = $(this).height(); }
  });
  $("#choix-inscription .card-header").height(maxHeightHeader);

  var maxHeightList = 0;
  $("#choix-inscription .list-unstyled").each(function(){
    if ($(this).height() > maxHeightHeader) { maxHeightList = $(this).height(); }
  });
  $("#choix-inscription .list-unstyled").height(maxHeightList);

  $("#home-meav-tendances__container__deplier").click(function() {
    $("#home-meav-tendances-blanc").css('height' , 'auto' );
    $("#home-meav-tendances__container__deplier").hide();
  });


  });

}(jQuery));
